import styled from "styled-components";
//import pdfico from "../../assets/ico-pdfgg.png"
import iconprint from "../../assets/ico-print.png"

export const Container = styled.div<{ antigo: boolean}>`
    display: block;
    flex: 1;
    margin: 0 10px;
    border-radius: 10px;
    height: 100%;
    box-shadow: 0px 1px 5px -1px rgb(0 0 0 / 15%);
    padding-bottom: 176px;

    table{
        width: 100%;
        border-collapse: collapse;
        z-index: 2;

        td, th{ position: relative; padding: 2px; background-color: ${props => props.antigo ? '#e7e3d9' : '#fff'} }
        tr.hover td{
            background-color: ${props => props.antigo ? '#DCD8CE' : '#F3F3F3'};
            transition: 0.9s;
        }
        
        th{ background: transparent }
        tr{ border-bottom: 1px #EDEDED solid; height:44px}
        tr th:first-child{ 
            width: 100%;
            padding: 12px 0 11px 12px;
            text-align: left;
        }        
        tr th:last-child{
            padding-right: 5px;
        }
        tr td:last-child{
            padding-right: 5px;
        }
    }

    @media(max-width: 860px) {
        margin: 0 0 0 10px;
    }
    @media(max-width: 280px) {
        margin: 0 0 0 6px;
        table th{
          padding: 0px;
        }
    }
`
export const TitCiclo = styled.div<{ antigo?: boolean}>`
    h2{
        color: ${props => !props.antigo ? 'var(--pink)' : 'var(--darkblue)'};
        display: block;
        text-transform: uppercase;
        font-style: italic;
        font-size: 1rem;
        font-weight: 100;
        white-space: nowrap;
        margin-bottom: -0.3rem;
    }
    span{
        font-weight: 300;
        font-size: 0.65rem;
        text-transform: uppercase;
        margin-left: 0.1rem;
        white-space: nowrap;
    }
    @media(max-width: 280px) {
      h2{
        font-size: 0.8rem;
      }
    }

`
export const Rotulo = styled.span`
    text-transform: uppercase;
    font-weight: 700;
    font-size: 0.7rem;
    transform: rotate(-90deg);
    display: block;
    overflow: hidden;
    width: 2rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;

    &:hover{
        overflow: visible;
    }
    @media(max-width: 280px) {
      width: 1.7rem;
    }
`
export const Sensacao = styled.div<{edit:boolean, obs: boolean}>`
    font-weight: 700;
    display: block;
    text-transform: uppercase;
    font-size: 0.82rem;
    line-height: 0.7rem;
    cursor: ${props => props.edit ? 'pointer' : 'inherit'};
    padding: ${props => props.obs ? '8px 0 6px 12px' : '6px 0 6px 12px'}; 
    height: ${props => props.obs ? '39px' : 'unset'};

    button{
        font-size: 0.6rem;
        text-transform: uppercase;
        background: none;
        border: dashed 1px rgba(0,0,0,0.5);
        border-radius: 5px;
        padding: 4px 5px;
        opacity: 0.3;
        margin-top: 3px;


        &:hover{
            opacity: 0.7;
        }
    }
    button.disable{
        display: none;
    }
    
    span{
      display: block;
      width: 94%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
`
export const Obs  = styled.div<{antigo?: boolean, size: number}>`

    font-weight: 400;
    font-size: 0.75rem;
    line-height: 0.8rem;
    text-transform: uppercase;
    color: #097694;
    display: block;
    margin: 1px 0 -2px -5px;
    width: 94%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    
    padding: 2px 5px 5px 5px;

        &:hover{
            transition: 0.9s;
            white-space: normal;
            background-color: ${props => props.antigo ? '#DCD8CE' : '#F3F3F3'};
            z-index: 1;
            box-shadow: ${props => props.size > 27 ? '1px 5px 7px -3px rgb(0 0 0 / 40%)' : 'unset'};
            border-radius: 4px;
        }

`


export const DiadoMes = styled.div`
    font-weight: 400;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 0.8rem;
    font-weight: 700;  
    color: #0d97bd;     

    small{
        text-transform: uppercase;
        font-size: 0.54rem;
        line-height: 0.4rem;
        font-weight: 200;
        color: #097694;
    }
`
export const RodapeCiclo = styled.div<{ isVisible?: boolean, antigo?: boolean, wfc: number}>`
    display: block;
    position: ${props => props.isVisible || props.antigo ? 'absolute' : 'fixed' };
    bottom: 0;
    width: ${props => props.wfc ? props.wfc+'px' : 'auto'};
    z-index: 1;
    padding: 15px;

    button, 
    .button{
        width: 100%;
        background: ${props => props.antigo ? 'rgba(0,0,0,0.05)' : 'rgba(0,0,0,0.07)' };
    }
    .add{
        background: ${props => props.antigo ? 'rgba(0,0,0,0.3)' : 'var(--pink)' };
    }
    .button{
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      text-decoration: none;
    }
    .treebtns{
        display: flex;
        gap: 4px;

        button{
          white-space: unset;
          padding-left: 5px;
          padding-right: 5px;
        }
    }

    .positPdf{
        display: block;    
        bottom: 0;
        width: 41px;
        height: 49px;
        position: absolute;
        right: 25px;
        top: 0.8rem;;
        background: none;
    }

`

export const RefFimCiclo = styled.div`
    display: block;
    position: absolute;
    bottom: 0;
`

export const IcoPdf = styled.div`
    display: block;    
    bottom: 0;
    background: url(${iconprint}); 
    width: 47px;
    height: 50px;
    opacity: 0.2;
    transition: 0.5s;

    &:hover{
        transition: 0.5s;
        opacity: 0.5;
    }
`